import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import type { AlertProps } from '@mui/material/Alert';

import { InfoAlert } from './InfoAlert';
import { MessageList } from './MessageList';

type Props = Omit<AlertProps, 'children' | 'title'> &
  Readonly<{
    messages: readonly string[];
    // The introductory message of the list.
    title?: string;
  }>;

// Several messages are listed one per line, under their introductory one; an information may be
// closed.
export const AlertMessages = ({
  messages,
  title,
  severity,
  ...alertProps
}: Readonly<Props>) => {
  const content = (
    <>
      {!!title && <AlertTitle>{title}</AlertTitle>}
      <MessageList messages={messages} />
    </>
  );

  return severity === 'info' ? (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <InfoAlert {...alertProps}>{content}</InfoAlert>
  ) : (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Alert {...alertProps} severity={severity}>
      {content}
    </Alert>
  );
};
